export const adobeScriptId = "adobeDTMScript";
export const adobeScriptSource = "https://assets.adobedtm.com/launch";

export const doesAdobeScriptExist = () =>
  !!document.getElementById(adobeScriptId) ||
  !!document.querySelector(`script[src^="${adobeScriptSource}"]`);

export const injectAdobeScript = (adobeSource: string) => {
  const adobeAnalytics = document.createElement("script");
  adobeAnalytics.type = "text/javascript";
  adobeAnalytics.async = true;
  adobeAnalytics.src = adobeSource;
  adobeAnalytics.setAttribute("id", "adobeDTMScript");
  document.head.append(adobeAnalytics);
};
